import { QueryClient, useQuery } from '@tanstack/react-query';
import { spaPackageApiClient } from '@utils/api/catalogue/spaPackage.api';
import { toCamelCase } from 'case-converter';
import { Package, PackageSchema } from './types';

export const ratesKeys = {
  rates: ['rates'] as const,
  packages: ['packages'] as const,
  package: (rateId: string, propertyUuid?: string) => [...ratesKeys.packages, rateId, propertyUuid],
};

export function useGetPackage({
  propertyUuid,
  rateId,
  enabled = true,
}: {
  propertyUuid: string;
  rateId: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ratesKeys.package(rateId, propertyUuid),
    queryFn: () =>
      getPackage({
        propertyUuid,
        rateId,
      }),
    enabled,
  });
}

export const getPackage = async ({
  rateId,
  propertyUuid,
}: {
  rateId: string;
  propertyUuid?: string;
}): Promise<Package | undefined> => {
  const { data } = await spaPackageApiClient.packagesFindOne({
    propertyId: propertyUuid ?? '',
    rateId,
  });
  const result = PackageSchema.safeParse(toCamelCase(data));
  if (result.success) {
    return result.data;
  }
  return undefined;
};

export const getPackagePrefetch = ({
  queryClient,
  rateId,
  propertyUuid,
}: {
  queryClient: QueryClient;
  rateId: string;
  propertyUuid: string;
}) =>
  queryClient.prefetchQuery(ratesKeys.package(rateId, propertyUuid), () =>
    getPackage({ rateId, propertyUuid })
  );
